import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Axios } from '../utils/Axios';
import Table from '../ui/Table/Table';
import Thead from '../ui/Table/Thead';
import Container from '../ui/comp/Container';
import Td from '../ui/Table/Td';
import Loading from '../components/Loading';
import Tbody from '../ui/Table/Tbody';
import FormatCurrency from '../utils/FormatCurrency';
import Status from '../ui/Table/Status';
import Select from '../ui/comp/Select';
import { orderStatus } from '../utils/config';
import { FiEye, FiPrinter } from 'react-icons/fi';
import { RiShoppingBag2Line } from 'react-icons/ri';

function CustomersPage() {

    const { id } = useParams();
    const [customer, setcustomer] = useState({})
    const queryClient = useQueryClient()

    const { data, isLoading } = useQuery({
        queryKey: ['customer'],
        queryFn: async () => {
            const res = await Axios.get(`/customer/${id}/one`)
            return res.data;
        }
    })

    useEffect(() => { setcustomer(data || {}) }, [data])


    // Chnage Status

    // update status

    const { mutate } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/order/status', formData)

        },
        onSuccess: () => {
            queryClient.invalidateQueries(['orders'])
        }
    })

    const handleStatus = (id, type) => {
        mutate({ id, type })
    }



    if (isLoading) {
        return <Loading />
    }

    return (
        <div className='w-full relative'>
            {customer && customer?.orders?.length ? (
                <Container title={"Customer Order List"}>
                    <Table>
                        <Thead>
                            <tr>
                                <Td>Order No.</Td>
                                <Td>Order Time</Td>
                                <Td>Customer Name</Td>
                                <Td>Method</Td>
                                <Td>Amount</Td>
                                <Td>Status</Td>
                                <Td>Actions</Td>
                                <Td>Invoice</Td>
                            </tr>
                        </Thead>

                        <Tbody>
                            {customer?.orders?.map((order, i) => (
                                <tr key={i}>
                                    <Td>{order?.orderNumber}</Td>
                                    <Td>
                                        {new Date(order?.iat).toLocaleString('en-US',
                                            {
                                                month: 'short', day: '2-digit', year: 'numeric',
                                            })}
                                    </Td>
                                    <Td>{`${customer?.firstname} ${customer?.lastname}`}</Td>
                                    <Td>{`${order?.payment?.type}`}</Td>
                                    <Td><FormatCurrency amount={order?.totalPrice} /></Td>
                                    <Td><Status status={order?.status} /></Td>
                                    <Td>
                                        <Select value={order?.status} onChange={(e) => handleStatus(order?.id, e.target?.value)}>
                                            {orderStatus.map((list, i) => (
                                                <option key={i} value={`${list}`}>{list}</option>
                                            ))}
                                        </Select>
                                    </Td>
                                    <Td>
                                        <div className="flex items-center gap-3 text-gray-500">
                                            <Link className='text-primary' to={`/orders/${order?.id}`} title='View'><FiEye size={20} /></Link>
                                            <button title='Print'><FiPrinter size={20} /></button>
                                        </div>
                                    </Td>
                                </tr>
                            ))}
                        </Tbody>
                    </Table>
                </Container>
            ) :
                <div className='w-full relative'>
                    <Container>
                        <div className="py-7 flex justify-center items-center flex-col space-y-4">
                            <div className="text-red-500">
                                <RiShoppingBag2Line size={40} />
                            </div>
                            <p className="text-center text-gray-500">This Customer have no order Yet! </p>
                        </div>
                    </Container>
                </div>
            }
        </div>
    )
}

export default CustomersPage